export default (eventDbID, eventID, dateID): string => `
     {
        meetingsSingle(id: "${eventDbID}", idType: DATABASE_ID) {
          registerOnEvent {
            request(eventID: ${eventID}, dateID: ${dateID})
          }
        }
    }
`;
